// Reset.
export const RESET = 'application/RESET';

// Ustawienie stanu.
export const SET_STATE = 'application/SET_STATE';

// Ustawienie informacji o dostępnej nowej wersji.
export const SET_NEW_VERSION_AVAILABLE = 'application/SET_NEW_VERSION_AVAILABLE';
